import { useState } from 'react'
import { useApp } from '../context/usePortal'
import {
  RegisterCredentialsRequestParams,
  RegisterCredentialsResponse,
  ayeApi,
} from '../core'
import { ConfirmCustomerRequestResponse } from '../core/api/http-methods/confirm-customer'
import useGuardedCallback, { GuardedReturn } from '../utils/useGuardedCallback'

export default function useRegistration(): {
  loading: boolean
  registerCredentials: ({
    phone_number,
    idv,
    idtp,
    method,
  }: Partial<RegisterCredentialsRequestParams['body']>) => Promise<
    GuardedReturn<RegisterCredentialsResponse | undefined>
  >
  confirmCustomer: (
    name?: string,
  ) => Promise<GuardedReturn<ConfirmCustomerRequestResponse | undefined>>
} {
  const [loading, setLoading] = useState<boolean>(false)
  const { detectedFace, setConsent, userPin, consent } = useApp()

  const registerCredentials = useGuardedCallback(
    async ({
      phone_number,
      idv,
      idtp,
      method,
    }: Partial<RegisterCredentialsRequestParams['body']>) => {
      if (detectedFace) {
        const headers = new Headers()
        const registered = await ayeApi.registerCredentials({
          body: {
            pin: userPin.reduce((prev, current) => prev + current, ''),
            phone_number: phone_number!,
            idv: idv!,
            idtp: idtp!,
            face: detectedFace,
            method: method!,
          },
          headers,
        })
        if (!registered.consent) {
          return registered
        }
        setConsent(registered)
        return registered
      }
    },
    [detectedFace],
    setLoading,
  )
  const confirmCustomer = useGuardedCallback(
    async (name?: string) => {
      if (consent) {
        const headers = new Headers()
        const response = await ayeApi.confirmCustomer({
          body: {
            id: consent?.customer_id,
            name,
            confirmed: true,
          },
          headers,
        })
        return response
      }
    },
    [consent],
    setLoading,
  )
  return {
    loading,
    registerCredentials,
    confirmCustomer,
  }
}
